module.exports = __webpack_public_path__ + "static/media/new-Boards2.791fc7cd.jpg";